import i18n from "i18next";
import { initReactI18next } from "react-i18next"
import auth from "utils/Auth";
import translationEN from './locales/en/translation.json';
import translationTR from './locales/tr/translation.json';

// the translations
const resources = {
  en: {
    translation: translationEN
  },
  tr: {
    translation: translationTR
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "tr", // If does not find the language of the browser, is going to use english as a default language 
    lng: auth.getLanguage(),
    react: {
      useSuspense: true
    }
  });

export default i18n;